const NoCache = () => {

    var noCacheDivs = document.querySelectorAll(".no-cache");

    if(noCacheDivs) {
        for (var i = 0; i < noCacheDivs.length; i++) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", window.location.href, true);
            xhr.setRequestHeader("Cache-Control", "no-cache, must-revalidate");
            xhr.setRequestHeader("Expires", "Sat, 1 Jan 2000 00:00:00 GMT");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.send();
            console.log('x')
          }
    }

}

export default NoCache;